<template>
    <div>
        <config-main-title>Configurações do Faturamento</config-main-title>

        <div class="alert alert-info">
            Essas configurações são específicas para esse computador/navegador.
        </div>

        <az-input
            type="checkbox-group"
            label="Exibir matrícula na lista de guias"
            v-model="config.exibir_matricula" />

        <az-input
            type="checkbox-group"
            label="Exibir procedimento na lista de guias"
            v-model="config.exibir_procedimento" />

        <az-input
            type="checkbox-group"
            label="Exibir protocolo na lista de guias"
            v-model="config.exibir_protocolo" />

        <nav class="navbar fixed-bottom navbar-light bg-light">
            <div>
                <button type="button" class="btn btn-success mr-1" @click="atualizar()">Atualizar</button>
                <button type="button" class="btn btn-secondary" @click="voltar()">Retornar</button>
            </div>
        </nav>

    </div>
</template>

<script>
import ConfigMainTitle from '../../cadastros/shared/ConfigMainTitle.vue';
import AzInput from '../../shared/forms/AzInput.vue';

export default {
    data() { 
        return { 
            config: { 
                exibir_matricula: null, 
                exibir_procedimento: null,  
                exibir_protocolo: null, 
            },
        }
    },

    components: { 
        ConfigMainTitle, 
        AzInput, 
    },

    methods: { 
        atualizar () { 
            this.$util.setCookie(
                'fat-em', 
                this.config.exibir_matricula ? 'S' : 'N',
                this.config.exibir_matricula ? 365 * 5 : 1, 
            );

            this.$util.setCookie(
                'fat-ep', 
                this.config.exibir_procedimento ? 'S' : 'N',
                this.config.exibir_procedimento ? 365 * 5 : 1, 
            );

            this.$util.setCookie(
                'fat-ept', 
                this.config.exibir_protocolo ? 'S' : 'N',
                this.config.exibir_protocolo ? 365 * 5 : 1, 
            );

            this.$router.go(-1);
        },

        voltar() { 
            this.$router.go(-1);
        },
    },

    beforeMount() {
        this.config.exibir_matricula = this.$util.getCookie('fat-em') == 'S' ? true : false; 
        this.config.exibir_procedimento = this.$util.getCookie('fat-ep') == 'S' ? true : false; 
        this.config.exibir_protocolo = this.$util.getCookie('fat-ept') == 'S' ? true : false; 
    },

    mounted() { 
        this.$store.commit('setBreadcrumb', 
            [
                { name: "Faturamento", path: "/faturamento/visao"},
                { name: "Configurações", path: "/faturamento/config" }
            ]);
    },

}
</script>